/** Renders the deletion date the way the wall reads it: "1 April 2026". */
export const formatDeletionDate = (deletionAt: string): string =>
	new Intl.DateTimeFormat("en-GB", {
		day: "numeric",
		month: "long",
		year: "numeric",
		timeZone: "UTC",
	}).format(new Date(deletionAt));

/**
 * Whether the company's deletion date has already passed (PREC-3900, Important 8).
 *
 * The GDPR purge ships dark behind `COMPANY_HARD_DELETE_ENABLED=false`, so a company that reaches
 * day 90 simply sits in `DUE_FOR_DELETION` with `hardDeleteAt` in the past — indefinitely, and
 * with its data entirely intact. The wall's normal notice ("All of it is permanently deleted on
 * <date>") then tells that customer their data was destroyed while we are still holding it, which
 * is both untrue and the opposite of a reason to come back. The overdue copy is used instead.
 *
 * Compared against the current instant rather than the state, so it is right even when the state
 * lags: a date in the past is a date in the past whichever state the API reported.
 */
export const isDeletionOverdue = (deletionAt: string, now: Date = new Date()): boolean => {
	const deletionTime = new Date(deletionAt).getTime();

	return Number.isFinite(deletionTime) && deletionTime <= now.getTime();
};
